// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__20Uc-","value":"value__28W8K","valueContainer":"valueContainer__3Xt8I"};